import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'

const ChatMessageSetFollowUpModalUI = ({
  context, successMsg, errorList, setErrorList,
  updateMode, submitted, onSubmit, onCancelClick,
  toFollowUp, onToFollowUpChange, toFollowUpError, setToFollowUpError, booleanList
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Follow up'
    buttonLabel='Set'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputSelectSF type='select' name='toFollowUp'
      value={toFollowUp} onChange={onToFollowUpChange} optionList={booleanList}
      error={toFollowUpError} setError={setToFollowUpError}
    />
  </ModalFormUI>

export default ChatMessageSetFollowUpModalUI
